import {
  EmptyState as Empty,
  EmptyStateContainer,
} from 'module/ui/components/atoms/empty-state/empty-state';
import { faAdd } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@rocketlane/ui';
import { FormattedMessage } from 'react-intl';

export const EmptyState = ({
  onResourceAdd,
}: {
  onResourceAdd: (value: boolean) => void;
}) => (
  <EmptyStateContainer>
    <Empty
      title={
        <FormattedMessage id="settings.integrations.sf.resource_mappings.empty.title" />
      }
      message={
        <FormattedMessage id="settings.integrations.sf.resource_mappings.empty.message" />
      }
      primaryCTA={
        <Button
          onClick={() => onResourceAdd(true)}
          rightIcon={<FontAwesomeIcon icon={faAdd} />}
          variant="primary"
        >
          <FormattedMessage id="settings.integrations.sf.resource_mappings.add" />
        </Button>
      }
    />
  </EmptyStateContainer>
);
